<div class="content-container">
    <div class="tem-field">
        <label class="tem-field-label">{{title}}<span class="tem-field-required"> *</span></label>
        <nz-select [formControl]="tabs" [nzPlaceHolder]="title">
            <nz-option *ngFor="let item of options | async" [nzValue]="item.key" [nzLabel]="item.value|translateTA"></nz-option>
        </nz-select>
    </div>
    <div class="options">
        <button nz-button nzType="default" id="no-button" (click)="dialogRef.close(false)">{{'cancel'|translateTA}}</button>
        <button nz-button nzType="primary" id="yes-button" [disabled]="tabs.invalid" (click)="salvar()">{{'select'|translateTA}}</button>
    </div>
</div>
